import angular from 'angular';

angular.module('cloudX').directive('validateMagicmail', [
  function() {
    return {
      restrict: 'A',
      require: ['?ngModel', '^?bindErrors'],
      link: function(scope, element, attributes, ctrls) {
        var ngModel = ctrls[0];
        var bindErrors = ctrls[1];
        if (!ngModel) return;
        ngModel.$validators.email = function(modelValue) {
          //Allow empty, use the required validator to block empty values
          if (typeof modelValue === 'undefined' || modelValue === null || modelValue.length === 0)
            return true;
          if (!/^[^@]+$/.test(modelValue)) return false; //easy regex

          return /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))$/i.test(
            modelValue,
          );
        };
        if (bindErrors) {
          bindErrors.addError('email', 9, ['email']);
        }
      },
    };
  },
]);
